// extracted by mini-css-extract-plugin
export var center = "_6-2";
export var clickableRow = "_6-5";
export var expandedRow = "_6-7";
export var hoverable = "_6-4";
export var left = "_6-1";
export var right = "_6-3";
export var row = "_6-0";
export var selectedRow = "_6-6";
export var summaryRow = "_6-8";